import common from '@page/common/js/common';
import $ from 'jquery';
import { createApp, onMounted } from 'vue';

import useGlobalLayout from '@global/composable/useGlobalLayout';
import useFreeLayout from '@global/composable/useFreeLayout';

require('@global/vendors/slick');

const { globalLayout } = useGlobalLayout();
const { initSlick, transitionEffects } = useFreeLayout();

globalLayout({
  banner: {
    isOpen: true,
    opts: {
      dots: true,
      arrows: false,
      speed: 800,
      autoplay: true,
      autoplaySpeed: 5000,
    },
    squareOpts: {
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      arrows: true,
      speed: 800,
      responsive: [
        {
          breakpoint: 415,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            dots: false,
          },
        },
      ],
    },
    fullBanner: {
      play: 5000,
    },
  },
  popupOpen: true,
  popupShowOnce: false,
});

const app = createApp({
  setup() {
    onMounted(() => {
      setTimeout(() => {
        $('#page-home').css('opacity', '1');
      }, 100);
    });
  },
});
app.mount('#home-content');

initSlick();
transitionEffects();
